<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="Atomizing Wire"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="atomizing-wire"
              >
                <b-form-input
                  id="atomizing-wire"
                  v-model="search_condition.name"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="status"
              >
                <b-form-select
                  v-model="search_condition.isDelete"
                  :options="types.statuss"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'atomizingWire::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >
          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="device-table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                    (search_condition.pageNum - 1) * search_condition.pageSize +
                    1
                }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button
                  v-has="'atomizingWire::Modify'"
                  size="sm"
                  variant="info"
                  @click="edit(row.item, row.index, $event.target)"
                  class="mr-1"
                  >Modify</b-button
                >

                <b-button
                  v-if="row.item.isDelete"
                  v-has="'atomizingWire::Disable'"
                  size="sm"
                  variant="danger"
                  @click="enableOrDisable(row.item, row.index, $event.target)"
                  class="mr-1"
                  >Disable</b-button
                >

                <b-button
                  v-else
                  v-has="'atomizingWire::Enable'"
                  size="sm"
                  variant="info"
                  @click="enableOrDisable(row.item, row.index, $event.target)"
                  class="mr-1"
                  >Enable</b-button
                >
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    ref="page"
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  ></b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
    <!-- end main -->
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Flavor List component
 */
export default {
  components: {
    DatePicker,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Atomizing Wire",
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Data Dictionary",
          // href: "/"
        },
        {
          text: "Atomizing Wire",
          active: true,
        },
      ],
      tableData: [],
      totalRows: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        {
          key: "name",
          label: "Atomized Wire Name",
          class: "text-center",
        },
        {
          key: "isDelete",
          label: "Status",
          formatter: (value) => {
            return value == 1 ? "Enabled" : "Disabled";
          },
        },
        { key: "remarks", label: "Notes", class: "text-center" },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        name: "",
        isDelete: "",
      },
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "Enabled", value: 1, disabled: false },
          { text: "Disabled", value: 0, disabled: false },
        ],
      },
      isBusy: false,
      has_data: false,
    };
  },
  computed: {
    /**
     * 计算rows
     */
    rows() {
      return this.totalRows;
    },
  },
  created() {},
  mounted() {},
  methods: {
    provider(ctx) {
      this.isBusy = true;
      return this.$api.Flavor.atomizedWireList(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
      //this.$bvToast.toast(JSON.stringify(this.search_condition));
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.search_condition.pageNum = 1;
    },
    gotoAdd() {
      this.$router.push("atomizingWireAdd");
    },
    edit(item, index, button) {
      this.$router.push({ name: "atomizingWireEdit", params: item });
    },
    // 停用启用
    enableOrDisable(a, b, c) {
      this.$api.Flavor.atomizedWireEnableOrDisable({
        id: a.id,
        isDelete: a.isDelete === 0 ? 1 : 0,
      }).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
  },
};
</script>
